module.exports = __webpack_public_path__ + "img/证书2.fd1ba202.jpg";